import { defineMessages } from '@sm/intl';

export default defineMessages({
  help: {
    id: 'footerCopy.Help',
    defaultMessage: 'Help',
    description: '[Type: Link][Vis: low] - Link to the Help Center',
  },
  termsOfUse: {
    id: 'footerCopy.TermsOfUse',
    defaultMessage: 'Terms of Use',
    description: '[Type: Link][Vis: low] - Link to the Terms of Use',
  },
  privacyPolicy: {
    id: 'footerCopy.PrivacyPolicy',
    defaultMessage: 'Privacy Policy',
    description: '[Type: Link][Vis: low] - Link to the Privacy Policy',
  },
});
